import { ManualView } from 'components/shared/ManualView';
import { FC } from 'react';
import { MainTestStrings } from 'utils/strings';
interface TestManualProps {
  routeTo: () => void;
}

export const TestManual: FC<TestManualProps> = ({ routeTo }) => {
  return (
    <ManualView data={MainTestStrings().Manual} routeTo={() => routeTo()} />
  );
};
